module.exports = __webpack_public_path__ + "static/media/R-150XLHD.ef550371.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/R-150XLHD.png
// module id = 2100
// module chunks = 0